import { createSelector } from "@ngrx/store";

import { AppState } from "../store";
import { DocumentState } from ".";
import { toTranscriptSegments } from "./document.model";

const feature = (state: AppState) => state.document;

export const documentErrorSelector = createSelector(
  feature,
  (state: DocumentState) => state.documentError
);

export const currentDocumentSelector = createSelector(
  feature,
  (state: DocumentState) => state.currentDocument
);

export const convertedPdfSelector = createSelector(
  feature,
  (state: DocumentState) => state.convertedPdf
);

export const uploadStatusSelector = createSelector(
  feature,
  (state: DocumentState) => state.status
);

export const documentResultSelector = createSelector(
  feature,
  (state: DocumentState) => state.documentResult
);

export const supportedFileTypesSelector = createSelector(
  feature,
  (state: DocumentState) => state.supportedFileTypes
);

export const maxFileSizeBytesSelector = createSelector(
  feature,
  (state: DocumentState) => state.maxFileSizeBytes
);

export const modelTypeSelector = createSelector(
  feature,
  (state: DocumentState) => state.modelType
);

export const processingOptionSelector = createSelector(
  feature,
  (state: DocumentState) => state.selectedOption
);

export const tablesDataSelector = createSelector(
  feature,
  (state: DocumentState) => state.tablesData
);

export const uploadSessionSelector = createSelector(
  feature,
  (state: DocumentState) => state.uploadSession
);

export const uploadStepSelector = createSelector(
  feature,
  (state: DocumentState) => state.uploadStep
);

export const portalUploadStatusSelector = createSelector(
  feature,
  (state: DocumentState) => state.portalUploadStatus
);

export const portalUploadProgressSelector = createSelector(
  feature,
  (state: DocumentState) => state.portalUploadProgress
);

export const resolvedOptionsSelector = createSelector(
  feature,
  (state: DocumentState) => state.resolvedOptions
);

export const uploadResultSelector = createSelector(
  feature,
  (state: DocumentState) => state.uploadResult
);

export const transcriptionSelector = createSelector(
  feature,
  (state: DocumentState) => state.transcription
);

export const audioBlobSelector = createSelector(
  feature,
  (state: DocumentState) => state.audioBlob
);

export const audioContentSelector = createSelector(
  feature,
  (state: DocumentState) => state.documentResult?.audioContent ?? null
);

// Sorted, ms→sec view-model for the transcript UI. speaker is carried through
// as an opaque string (or null) — see NormalizedSegment.
export const transcriptSegmentsSelector = createSelector(
  transcriptionSelector,
  toTranscriptSegments
);
